var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 7.00033C6.33808 7.00033 6.83333 6.50508 6.83333 5.83366C6.83333 5.16224 6.33808 4.66699 5.66667 4.66699C4.99525 4.66699 4.5 5.16224 4.5 5.83366C4.5 6.50508 4.99467 7.00033 5.66667 7.00033Z",
    fill: "#AEAEAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 2.33301H2.33268C1.68927 2.33301 1.16602 2.82359 1.16602 3.42676V10.5726C1.16602 11.1758 1.68927 11.6663 2.33268 11.6663H11.666C12.3094 11.6663 12.8327 11.1758 12.8327 10.5726V3.42676C12.8327 2.82359 12.3094 2.33301 11.666 2.33301ZM11.666 10.4997L2.33268 10.4933V3.49967L11.666 3.50609V10.4997Z",
    fill: "#AEAEAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 4.66699H10.5V5.83366H8.16667V4.66699ZM8.75 7.00033H10.5V8.16699H8.75V7.00033ZM7.83417 8.47966C7.83417 7.67816 6.8565 6.85449 5.66708 6.85449C4.47767 6.85449 3.5 7.67816 3.5 8.47966V8.75033H7.83417V8.47966Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/ID.32895da9a69c896e3c2c0212357e5fba.svg";
export { ForwardRef as ReactComponent };